export const enquiryInfo = {
  firstName: "",
  lastName: "",
  fullName: "",
  // country: '',
  mobileNumber: "",
  // alternativeNumber: '',
  whatsappNumber: "",
  address1: "",
  address2: "",
  // city: '',
  // state: '',
  email: "",
  notes: "",
  // customerMessage: '',
  origin: "Enquiry_from_alpha",
  interestedProduct: "",
  plannedArea: "",
  gst_number: "",
  businessName: "",
  enquiryRelated: "",
  interestedIn: [],
  preferredLanguage: "",
};
